import React from 'react';
import { Icon, Button } from 'Components';
import PropTypes from 'prop-types';
import './NavMobileLink.css';

const NavMobileLink = ({
  icon,
  to,
  title,
  onClick,
}) => (
  <li className="nav-mobile-link">
    <Button onClick={e => onClick(e, to)}>
      { icon && <Icon icon={icon} /> }
      <span>{title}</span>
    </Button>
  </li>
);

NavMobileLink.propTypes = {
  to: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default NavMobileLink;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavMobile/NavMobileLink/NavMobileLink.jsx